export default __webpack_public_path__ + "static/media/rocket.9910005b.svg";